import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Card } from '../../models/card.model';

@Component({
  selector: 'app-summary-cards',
  templateUrl: './summary-cards.component.html',
  styleUrl: './summary-cards.component.scss'
})
export class SummaryCardsComponent {
  @Input() cards: Card[] = [];
  @Output() cardClick = new EventEmitter<string>();
  activeCard: any;
  @ViewChild('scrollWrapper') scrollWrapper?: ElementRef<HTMLDivElement>;

  private clickableTileIds = ['inReferral', 'underEvaluation', 'awaitingMRB'];

  constructor(private route: ActivatedRoute) {}

  @Input() set clearFiltersEvent(value: boolean) {
    if (value) {
      this.activeCard = null;
    }
  }

  onCardClick(card: any) {
    if (!this.isCardClickable(card)) return;

    if (this.activeCard?.title === card.title) {
      this.activeCard = null;
      this.cardClick.emit('');
    } else {
      this.activeCard = card;
      this.cardClick.emit(card.filterId);
    }
  }

  isCardClickable(card: any): boolean {
    return this.clickableTileIds.includes(card.id) &&
           !!this.route.snapshot.routeConfig?.path?.includes('donoroverview');
  }

  scrollRight() {
    const wrapper = this.scrollWrapper?.nativeElement;
    if (!wrapper) return;
    wrapper.scrollBy({ left: wrapper.clientWidth, behavior: 'smooth' });
  }
}
